export const fileToBase64 = (file: File): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const downloadFile = (name: string, text: string): void => {
  const file = new Blob([text], { type: "text/plain" });
  downloadFileFromURL(URL.createObjectURL(file), name);
};

export const downloadFileFromURL = (url: string, name = "") => {
  const link = document.createElement("a");
  link.download = name;
  link.target = "_blank";
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Downloads a file from URL with optional content transformation
 *
 * NOTE: This requires the S3 bucket to have CORS headers configured to allow
 * fetching from the application origin. If CORS is not configured, this will fail.
 *
 * @param url - URL to fetch the file from (must have proper CORS headers)
 * @param name - Name for the downloaded file
 * @param transform - Optional function to transform the file content before download
 */
export const downloadFileFromURLWithTransform = async (
  url: string,
  name: string,
  transform?: (content: string) => string
): Promise<void> => {
  const response = await fetch(url, {
    method: "GET",
    credentials: "omit", // Don't send credentials to S3
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch file: ${response.statusText}`);
  }

  let content = await response.text();

  if (transform) {
    content = transform(content);
  }

  const file = new Blob([content], { type: "text/plain" });
  downloadFileFromURL(URL.createObjectURL(file), name);
};
